export default {"src":"/_next/static/media/top_right_arrow_icon.3159afc8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};